import { useDispatch, useSelector } from 'react-redux';
import { inactiveTasksPageSelector } from '../../selectors/admin.selectors';
import { setInactiveTasksPage } from '../../actions/admin.actions';
import { useAnnotationTaskData } from '../../hooks/useAnnotationTaskData';
import { AnnotationTaskTable } from './AnnotationTaskTable';

export const AnnotationTaskInactive = () => {
  const dispatch = useDispatch();
  const inactiveTasksPage = useSelector(inactiveTasksPageSelector);
  const instanceInactive = useAnnotationTaskData('paused', inactiveTasksPage);
  const incrementInactivePage = () =>
    dispatch(
      setInactiveTasksPage({
        page: inactiveTasksPage + 1,
      }),
    );

  return (
    <>
      <AnnotationTaskTable
        instance={instanceInactive}
        incrementPage={incrementInactivePage}
      />
    </>
  );
};
